import { render, staticRenderFns } from "./TextLink.vue?vue&type=template&id=e5f01ed2&scoped=true&"
import script from "./TextLink.vue?vue&type=script&lang=ts&"
export * from "./TextLink.vue?vue&type=script&lang=ts&"
import style0 from "./TextLink.vue?vue&type=style&index=0&id=e5f01ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f01ed2",
  null
  
)

export default component.exports